import React from "react";
import { Box, Typography } from "@mui/material";
import { BankStatementsView } from "../components/BankStatementsView";

const BankStatementsPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Extratos Bancários
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Faça upload e gerencie os seus extratos bancários.
        </Typography>
      </Box>
      <BankStatementsView />
    </Box>
  );
};

export default BankStatementsPage;
